
export const common = {
  // Navigation
  contact: "Contacto",
  about: "Sobre mí",
  projects: "Proyectos",
  learnMore: "Saber más",
  contactMe: "Contáctame",
  
  // Hero Section
  heroTitle: "Iker Peralta Condes",
  heroSubtitle: "Cyber Threat Intelligence Analyst",
  heroTerminal: "> Inicializando sistemas de threat intelligence...",
  threatDetection: "Detección y Análisis de Amenazas",
  darkWebIntel: "Inteligencia Dark Web",
  threatHunting: "Threat Hunting y Operaciones SOC",
  
  // About Section
  aboutTitle: "Sobre mí",
  aboutTerminal: "cat about.txt",
  aboutIntro: "Holaa!! 👋 me llamo Iker y me apasiona la ciberseguridad, sobre todo analizar amenazas, seguirle la pista a los atacantes😈 y adelantarme a lo que van a hacer.",
  aboutP1: "Mi formación en sistemas y redes me dio una base técnica sólida que hoy aplico para entender cómo piensan y actúan los atacantes y cómo proteger los entornos digitales de manera efectiva.",
  aboutP2: "Me he especializado en Cyber Threat Intelligence (CTI), Threat Detection, Threat Hunting y operaciones de SOC, apoyando a equipos de Incident Response con inteligencia accionable.",
  aboutP3: "Me gusta mantenerme al día con las últimas herramientas, técnicas y vulnerabilidades, experimentar con nuevas metodologías y compartir IOCs con otros profesionales de la ciberseguridad.",
  aboutP4: "Mi objetivo es aportar valor real en cada proyecto, combinando visión estratégica y capacidad de análisis técnico como CTI Analyst y Cybersecurity Analyst.",
  aboutP5: "Me motivan los retos, estoy comprometido con el trabajo en equipo y siempre busco oportunidades para crecer en el campo de la ciberseguridad.",
  coreCompetencies: "// Competencias Principales",
  personalIntroduction: "// Introducción Personal",
  professionalProfile: "// Perfil Profesional",
  linkedinTitle: "LinkedIn - Iker Peralta Condes",
  linkedinDesc: "Conecta conmigo para oportunidades profesionales y networking en ciberseguridad",
  
  // Skills
  skill1Title: "Cyber Threat Intelligence (CTI)",
  skill1Desc: "Recopilación, análisis y contextualización de inteligencia de amenazas cibernéticas",
  skill2Title: "Monitoreo de Actores de Amenaza",
  skill2Desc: "Monitoreo de actores de amenaza, campañas y TTPs (basado en MITRE ATT&CK)",
  skill3Title: "Investigación Deep & Dark Web",
  skill3Desc: "Investigación en deep y dark web para perfilado de actores de amenaza y detección temprana",
  skill4Title: "Reportes de Inteligencia e IOCs",
  skill4Desc: "Desarrollo y difusión de reportes de amenazas, Indicadores de Compromiso (IOCs) y TTPs",
  skill5Title: "Gestión de Plataforma MISP",
  skill5Desc: "Uso de plataformas de inteligencia avanzadas, incluyendo MISP para compartir y correlacionar datos de amenazas",
  skill6Title: "Soporte SOC e IR",
  skill6Desc: "Soporte a equipos SOC e IR con inteligencia enriquecida para detección y respuesta",
  skill7Title: "Seguimiento de Vulnerabilidades",
  skill7Desc: "Seguimiento continuo de CVEs, zero-days y actividad en foros underground",
  
  // Projects Section
  projectsTitle: "Proyectos",
  projectsTerminal: "ls -la projects/",
  projectsSubtitle: "Explora mis contribuciones al ecosistema de ciberseguridad y threat intelligence",
  githubTitle: "GitHub Repository",
  githubDesc: "Repositorios de código, herramientas de CTI, scripts de análisis y proyectos de ciberseguridad",
  githubStats: "Proyectos Open Source",
  twitterTitle: "X / Twitter",
  twitterDesc: "Análisis de amenazas, IOCs, investigación en tiempo real y insights de ciberseguridad",
  twitterStats: "Actualizaciones de Threat Intelligence",
  explore: "Explorar",
  active: "Activo",
  contributing: "Contribuyendo al ecosistema de threat intelligence",
  
  // Contact Section
  contactTitle: "Contacto",
  contactTerminal: "establish_connection",
  contactSubtitle: "Conectemos para discutir oportunidades en ciberseguridad y threat intelligence",
  sendMessage: "// Enviar Mensaje",
  socialNetworks: "// Redes Sociales",
  systemStatus: "// Estado del Sistema",
  
  // Form
  nameLabel: "Nombre",
  emailLabel: "Email",
  messageLabel: "Mensaje",
  namePlaceholder: "Tu nombre completo",
  emailPlaceholder: "tu@email.com",
  messagePlaceholder: "Cuéntame sobre tu proyecto o consulta...",
  sendButton: "Enviar mensaje",
  sending: "Enviando...",
  successMessage: "✓ Mensaje enviado correctamente. Te responderé pronto.",
  errorMessage: "✗ Error al enviar el mensaje. Inténtalo de nuevo.",
  
  // Status
  statusOnline: "● Online",
  responseTime: "< 24h",
  availability: "24/7",
  status: "Estado:",
  responseTimeLabel: "Tiempo de Respuesta:",
  availabilityLabel: "Disponibilidad:",
  
  // Footer
  footerText: "© 2025 Iker Peralta Condes — Todos los Derechos Reservados.",
  
  // Language
  language: "Idioma",
  spanish: "Español",
  english: "English"
};